module.exports = __webpack_public_path__ + "img/torcendo.3a3796a4.png";